/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./editMetrics.vue?vue&type=template&id=23a7c35e&scoped=true"
import script from "./editMetrics.vue?vue&type=script&lang=js"
export * from "./editMetrics.vue?vue&type=script&lang=js"
import style0 from "./editMetrics.vue?vue&type=style&index=0&id=23a7c35e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a7c35e",
  null
  
)

export default component.exports